import * as React from "react";
import { Checkbox, CheckboxProps, Grid, Icon, Popup, SemanticSIZES } from "semantic-ui-react";
import { IconSizeProp } from "semantic-ui-react/dist/commonjs/elements/Icon/Icon";
import { Text } from "../text";

interface ICheckBox extends CheckboxProps {
  label: string;
  popupMessage?: string;
  style?: any;
  disabled?: boolean;
  checked?: boolean;
  fluid?: boolean;
  id?: string;
  size?: "small" | "medium" | "large";
  value?: any;
  onSelect: (value: any, checked: boolean) => void;
}

interface ISizeStyle {
  sizeText: SemanticSIZES;
  sizeIcon: IconSizeProp | undefined;
}

class CheckBox extends React.Component<ICheckBox> {
  public static defaultProps = {
    allowFontScaling: false,
  };
  public render() {
    const { label, popupMessage, id, disabled, checked, fluid, value, onSelect } = this.props;
    const sizeStyle = this.getSize();
    return (
      <Grid style={styles.grid}>
        <Grid.Row
          columns={popupMessage && fluid ? 2 : 1}
          verticalAlign="middle"
        >
          <Grid.Column floated="left" textAlign="left" computer={14}>
            <Checkbox
              label={
                <label>
                  <Text shade={2} size={sizeStyle.sizeText}>
                    {label}
                  </Text>
                </label>
              }
              id={id || "check-box"}
              checked={checked}
              disabled={disabled}
              onChange={(event: any, val: any) => onSelect(value, val.checked)}
            />
            {popupMessage && !fluid ? this.renderPopup() : null}
          </Grid.Column>
          {popupMessage && fluid ? (
            <Grid.Column floated="right" textAlign="right" computer={2}>
              {this.renderPopup()}
            </Grid.Column>
          ) : null}
        </Grid.Row>
      </Grid>
    );
  }

  public renderPopup() {
    const { popupMessage } = this.props;
    const sizeStyle = this.getSize();
    return (
      <Popup
        trigger={
          <Icon
            name="question circle"
            color={"grey"}
            size={sizeStyle.sizeIcon}
          />
        }
        content={popupMessage}
      />
    );
  }
  private getSize = () => {
    const { size } = this.props;
    const style: ISizeStyle = {
      sizeText: "medium",
      sizeIcon: undefined,
    };
    switch (size) {
      case "small":
        style.sizeText = "tiny";
        style.sizeIcon = "small";
        break;
      case "medium":
        style.sizeText = "large";
        style.sizeIcon = undefined;
        break;
      case "large":
        style.sizeText = "big";
        style.sizeIcon = "large";
        break;
      default:
        style.sizeText = "large";
        style.sizeIcon = undefined;
        break;
    }
    return style;
  };
}

const styles = {
  grid: {
    marginTop: 0,
  },
  icon: {
    marginLeft: 10,
  },
};

export default CheckBox;
